import React from 'react';

const Footer = ({ currentVersion, siteName }) => {
  const getVersionNumber = (version) => {
    if (!version) return 'Unknown';
    return version.replace('Portal.v', '');
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 px-6 py-2">
      <div className="flex items-center justify-between">
        <div className="text-sm text-gray-500">
          © {currentYear} {siteName || 'Silulumanzi Portal'}
        </div>
        <div className="text-sm text-gray-500">
          v{getVersionNumber(currentVersion)}
        </div>
      </div>
    </footer>
  );
};

export default Footer;